import React from "react";


import {
    UserDashboardPageContentSection
} from "@Pages/@@UserPages/@Dashboard/@@Parts";

import {
    DashboardInformationCardElementComponent
} from "@Components/@Elements/@Cards/@Dashboard/@Information";


import IconLinkSm from "./@Icons/icon-link-sm.svg";
import IconCheckSm from "./@Icons/icon-check-sm.svg";
import IconWarningSm from "./@Icons/icon-warning-sm.svg";


import "./index.scss";


export const UserDashboardConnectedAppsSummarySection:React.FC = () => {

    return (
        <UserDashboardPageContentSection
            sectionName={'user-connected-apps-summary'}
            sectionHeaderText={'Connected Services'}
            sectionDescriptionText={'Manage third-party applications that have access to your account'}
        >

            <DashboardInformationCardElementComponent
                cardIcon={IconLinkSm}
                cardHeaderText={'Total Connected'}
                cardContentText={'8'}
                cardType={'info'} cardSize={'md'}
            />

            <DashboardInformationCardElementComponent
                cardIcon={IconCheckSm}
                cardHeaderText={'Active'}
                cardContentText={'6'}
                cardType={'success'} cardSize={'md'}
            />

            <DashboardInformationCardElementComponent
                cardIcon={IconWarningSm}
                cardHeaderText={'Needs Attention'}
                cardContentText={'2'}
                cardType={'warning'} cardSize={'md'}
            />

        </UserDashboardPageContentSection>
    );

};


export default UserDashboardConnectedAppsSummarySection;
